import { Card, CardContent, Typography } from "@mui/material";
import { ICandidateReview } from "../../../../../App/Typings/Candidate";
import Ratings from "../Ratings";
import ReviewHelpful from "./ReviewHelpful";

export function Review({ review }: { review: ICandidateReview }) {
  return (
    <>
      <Card
        sx={{
          my: 3,
          width: 1,
        }}
        elevation={3}
      >
        <CardContent data-test={`reviewcard-${review.reviewerId}`}>
          {review.id === "" ? (
            <Typography
              id={`review-loading-${review.reviewerId}`}
              data-test={`review-loading-${review.reviewerId}`}
              sx={{ fontWeight: 600 }}
            >
              Uploading review...
            </Typography>
          ) : (
            <>
              <Ratings stars={review.rating} setStars={null} readOnly={true} />
              <Typography
                id={`review-reviewerid-${review.reviewerId}`}
                data-test={`review-reviewername-${review.reviewerNickname}`}
                sx={{ fontWeight: 600 }}
              >
                {review.reviewerName ?? review.reviewerNickname ?? review.reviewerUsername}
                &nbsp;says:
              </Typography>
              <Typography id={`review-${review.id}`} data-test={`review-${review.id}`}>
                {review.review}
              </Typography>
              <ReviewHelpful review={review} />
            </>
          )}
        </CardContent>
      </Card>
    </>
  );
}
